import { useNavigate } from "react-router-dom";

export default function Topbar({ userName, onRefresh, refreshing }) {
  const navigate = useNavigate();
  const name = userName || localStorage.getItem("userName") || "Guest";

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userName");
    localStorage.removeItem("admin_user");
    navigate("/login", { replace: true });
  };

  return (
    <div className="topbar">
      <div className="brand">
        <div className="logo">⚡</div>
        <div className="meta">
          <div className="title">Admin Console</div>
          <div className="sub">User & Subscription Management</div>
        </div>
      </div>

      <div className="top-actions">
        <button
          type="button"
          className="btn light"
          onClick={onRefresh}
          disabled={!!refreshing}
        >
          {refreshing ? "Refreshing…" : "Refresh"}
        </button>
        <button type="button" className="btn danger" onClick={logout}>
          Logout
        </button>
        <div className="avatar" title={name}>
          {name?.[0]?.toUpperCase() || "U"}
        </div>
      </div>
    </div>
  );
}
